export default __webpack_public_path__ + "static/media/spider-man.b607a417.png";